const Textarea = {
    baseStyle: {
        _placeholder: {
            color: 'neutral.500',
            fontWeight: 400,
        },
        bg: 'transparent',
        borderColor: 'neutral.500',
        fontSize: 'var(--input-font-size)',
        fontWeight: 400,
        textAlign: 'left',
        transition: 'none',
    },
    variants: {
        ghost: {
            borderRadius: 0,
            boxShadow: 'none',
            padding: 0,
        },
    },
};
export { Textarea };
